module.exports = __webpack_public_path__ + "static/media/bespoke.393b05db.jpg";